import { render, staticRenderFns } from "./kbank.vue?vue&type=template&id=20f972a4&scoped=true&"
import script from "./kbank.vue?vue&type=script&lang=js&"
export * from "./kbank.vue?vue&type=script&lang=js&"
import style0 from "./kbank.vue?vue&type=style&index=0&id=20f972a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f972a4",
  null
  
)

export default component.exports